<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="title"
                        :isNewButton="checkPermission('microsoftteamgroupuser_store')"
                        @new-button-click="createFormShow"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="title"
                              :isNewButton="checkPermission('microsoftteamgroupuser_store')"
                              @new-button-click="createFormShow"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                @filter="filter"
                @filterClear="filterClear"
            >
                <b-row>
                    <b-col sm="6">
                        <b-form-group :label="$t('user')">
                            <PersonsAutoComplete v-model="datatable.queryParams.filter.user_id"
                                                 :returnType="'id'"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('user_type')">
                            <parameter-selectbox code="microsoft_team_group_user_types" v-model="datatable.queryParams.filter.type" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('roles')">
                            <parameter-selectbox code="microsoft_team_group_roles" v-model="datatable.queryParams.filter.role" />
                        </b-form-group>
                    </b-col>

                </b-row>
            </datatable-filter>
            <datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :lineNumbers="false"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </datatable>
            <CommonModal ref="createFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('microsoftteamgroup_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess==='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('microsoftteamgroup_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess==='update'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from "@/layouts/AppLayout";
    import Header from "@/layouts/AppLayout/Header"
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    //Component
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import Datatable from "@/components/datatable/Datatable";
    import CommonModal from "@/components/elements/CommonModal";
    //Other
    import qs from "qs";
    import CreateForm from "./CreateForm"
    import UpdateForm from "./UpdateForm"
    import MicrosoftTeamsGroupServices from "@/services/MicrosoftTeamsGroupServices";
    import MicrosoftTeamsGroupUsersServices from "@/services/MicrosoftTeamsGroupUsersServices";
    import PersonsAutoComplete from "@/components/interactive-fields/PersonsAutoComplete.vue";
    export default {
        components: {
            PersonsAutoComplete,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,

            CreateForm,
            UpdateForm,
        },
        metaInfo() {
            return {
                title: this.title
            };
        },
        data() {
            return {
                groupInformation:{
                    group_name:null
                },
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: "",
                            field: "buttons",
                            html: true,
                            sortable: false,
                            tdClass: "p-0 text-center w-40 align-middle",
                            buttons: [
                                {
                                    text: this.$t("update"),
                                    class: "ri-edit-box-line",
                                    permission: 'microsoftteamgroupuser_update',
                                    callback: (row) => {
                                        this.loadData(row.id);
                                    },
                                },
                                {
                                    text: this.$t("delete"),
                                    class: "ri-delete-bin-2-line",
                                    permission: 'microsoftteamgroupuser_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    },
                                },
                            ],
                        },
                        {
                            label: this.$t("id"),
                            field: "id",
                            sortable: true,
                        },
                        {
                            label: this.$t("role"),
                            field: this.getLocaleField('role_name'),
                            sortable: false,
                        },
                        {
                            label: this.$t("user_type"),
                            field: this.getLocaleField('type_name'),
                            sortable: false,
                        },
                        {
                            label: this.$t("name") +  ' ' +this.$t('surname'),
                            field: "name",
                            sortable: false,
                            formatFn:(row,column)=>{
                                return column.name + ' ' +column.surname
                            }
                        },
                        {
                            label: this.$t("email"),
                            field: "email",
                            sortable: false,
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {
                        },
                        sort: "id",
                        page: 1,
                        limit: 20,
                    },
                },
            };
        },
        computed:{
            title(){
                return this.$t('microsoft_teams_group') + ' - ' +this.groupInformation.group_name
            }
        },
        created() {
          this.getGroupInformation()
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == "desc" ? "-" : "";
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getGroupInformation(){
                MicrosoftTeamsGroupServices.get(this.$route.params.id)
                    .then((response) => {
                        this.groupInformation=response.data.data
                    })
                    .catch((error) => {
                        if (error.data.message) {
                            this.$toast.error(this.$t("api." + error.data.message));
                        }
                    }).finally(()=>{
                    this.formLoading = false;
                });
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams,
                        filter: {
                            microsoft_team_group_id: this.$route.params.id,
                        }
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };

                return MicrosoftTeamsGroupUsersServices.getAll(config).then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                }).finally(() => {
                    this.datatable.isLoading = false;
                });
            },
            delete(id) {
                this.deleteModal(() => {
                    MicrosoftTeamsGroupUsersServices.del(id)
                                    .then((response) => {
                                        this.filter();
                                        this.$toast.success(this.$t("api." + response.data.message));
                                    })
                                    .catch((error) => {
                                        this.$toast.error(this.$t("api." + error.data.message));
                                    });
                });
            },
            loadData(id){
                this.formProcess='update'
                this.formId=id
                this.$refs.updateFormModal.$refs.commonModal.show()
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
        },
    };
</script>

